import { ModalConfig } from '@zipari/shared-ds-util-modal';

export interface ExternalSiteModalConfig extends ModalConfig {
  title: string;
  description: string;
  footerCancelButton: string;
  footerProceedButton: string;
}
